import React from 'react';
import { FormattedDate, FormattedTime, defineMessages } from 'react-intl';
import { useMessage } from '@tmapy/intl';

import type { DocHistoryResponse } from '../../openapi/types';
import { DocBadge } from '../../docs/components/DocBadge';

const msg = defineMessages({
  historyListUpdaterNull: {
    id: 'historyList.updaterNull',
    defaultMessage: 'Systémová změna',
  },
});

export const HistoryListItem: React.FC<DocHistoryResponse> = (props) => {
  const formatMessage = useMessage();
  const updater = props.updater
    ? `${props.updater.name ?? ''} ${props.updater.surname ?? ''}`.trim()
    : formatMessage(msg.historyListUpdaterNull);

  return (
    <tr>
      <td>
        <DocBadge docState={props.state} flow={props.flow} />
      </td>
      <td className='sg-a-va-b sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.updated && (
          <time className='sg-u-type-sml sg-u-c-body-darkest' dateTime={props.updated}>
            <FormattedDate value={new Date(props.updated)} />{' '}
            <FormattedTime
              value={new Date(props.updated)}
              hour='numeric'
              minute='numeric'
              second='numeric'
            />
          </time>
        )}
      </td>
      <td className='sg-a-va-b'>{updater}</td>
    </tr>
  );
};
